import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch  } from 'react-redux';
import { userActions } from './store/user-slice';
import { clientActions } from './store/client-slice';
import { verifyCookie } from './lib/verify-cookies';
import jwt_decode from 'jwt-decode';
import './App.css';
import Login from './components/Login/Login';
import Authenticate from './components/Login/Authenticate';
import { Route, Routes } from 'react-router-dom';
// Components

import InputSubmission from './components/Pages/InputSubmission';
import Home from './components/Pages/Home';
import Logout from './components/Login/Logout';
import Rnd1ReviewHome from './components/Pages/Rnd1ReviewHome';
import ReviewSub from './components/Pages/ReviewSub';
import SubViwer from './components/Pages/SubViewer';
import ThankYou from './components/Pages/ThankYou';
import TestBcrypt from './components/Pages/TestBcrypt';
import LoginDb from './components/Login/LoginDb';
window.Buffer = window.Buffer || require( 'buffer' ).Buffer;

function App() {
  const dispatch = useDispatch( false );
  const [isAuthenticated, setIsAuthenticated] = useState();



  useEffect( () => {
    const authCookie = verifyCookie( 'neon_access_token' );
    const clientCookie = verifyCookie( 'auth_code' );
    if ( authCookie && clientCookie && !isAuthenticated ) {
      dispatch( userActions.setIsLoggedIn( authCookie ) );
      setIsAuthenticated( true );
      const jwToken = jwt_decode( clientCookie );
      const storeData = {
        apiKey: jwToken.apiKey,
        neonClientName: jwToken.neonClientName,
        neonOauthId: jwToken.neonOauthId,
        neonOauthSecret: jwToken.neonOauthSecret
      };

      dispatch (
        clientActions.setNeonApiKey( storeData )
      );
    }
  }, [dispatch, isAuthenticated] );

  const isAuth = useSelector( state => state.user.isLoggedIn );


  return (
    <div className="wrapper">
      <Routes>
        <Route path="/" element={<Home auth={isAuth} />} />
        <Route path="/login" element={<Login/>} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/authenticate" element={<Authenticate />} />
        <Route path="/application" element={<InputSubmission auth={isAuth}/>} />
        <Route path="/rnd1review" element={<Rnd1ReviewHome />} />
        <Route path="/rnd1review/:id" element={<ReviewSub />} />
        <Route path="/rnd1view/:id" element={<SubViwer />} />
        <Route path="/application/thankyou" element={<ThankYou />} />
        <Route path="/testEncryption" element={<TestBcrypt />} />
        <Route path="/review/login" element={<LoginDb />} />
      </Routes>
    </div>
  );
}

export default App;